import { render, staticRenderFns } from "./CompetenceList.vue?vue&type=template&id=cbde49cc&"
import script from "./CompetenceList.vue?vue&type=script&lang=js&"
export * from "./CompetenceList.vue?vue&type=script&lang=js&"
import style0 from "./CompetenceList.vue?vue&type=style&index=0&id=cbde49cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports